import { api as defaultApi } from './api';
import { actionCreators } from './actions';
import { bindActionCreators } from 'redux';
import { useDispatch } from 'react-redux';
import { useMemo } from 'react';
import { safeNumericString } from 'app/infrastructure/data/sanitize';

export function useActionCreators(api: any = defaultApi) {
  const dispatch = useDispatch();
  
  return useMemo(
    () => bindActionCreators(actionCreators(api), dispatch), 
    [dispatch, api]
  );
}

export function useSelectors(params: any, router: any) {
  return {
    caseTypeId: safeNumericString(params.caseTypeId?.split('?')[0]) || undefined,
    caseContextId: router.location.query && safeNumericString(router.location.query.caseContextId) || undefined,
    parentConnection: router.location.query && ({
      draftId: safeNumericString(router.location.query.draftId) || undefined,
      connectionTypeId: safeNumericString(router.location.query.connectionTypeId) || undefined
    })
  };
}
